import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTickSmallCorrectBlue({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={8} cy={8} r={8} fill="#0C8BE6" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M6.72 10.85l-2.6-2.6a.4.4 0 010-.57l.56-.56a.4.4 0 01.57 0L7 8.87l3.75-3.75a.4.4 0 01.57 0l.56.56a.4.4 0 010 .57l-4.6 4.6a.4.4 0 01-.56 0"
        clipRule="evenodd"
      />
    </svg>
  );
}

SvgTickSmallCorrectBlue.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTickSmallCorrectBlue.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgTickSmallCorrectBlue svgRef={ref} {...props} />
));
export default ForwardRef;
